import { render, staticRenderFns } from "./CompProfileSkeletonBasicCard.vue?vue&type=template&id=011c7b23&scoped=true"
import script from "./CompProfileSkeletonBasicCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CompProfileSkeletonBasicCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011c7b23",
  null
  
)

export default component.exports